export const handleBookCall = () =>
  window.open(
    "https://calendly.com/sven-badalyan/call-with-sven-genai-expert",
    "_blank",
  );
